import React from "react";
import { Outlet } from "react-router-dom";

const VendorHome = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default VendorHome;
